let ClickTraceHandlers:{predicate:(el:HTMLElement,evt:Event)=>boolean,handler:(el:HTMLElement,evt:Event)=>void}[]=[];

export function AddClickTraceHandler(predicate:(el:HTMLElement,evt:Event)=>boolean,handler:(el:HTMLElement,evt:Event)=>void) {
  ClickTraceHandlers.push({predicate,handler});
}
document.addEventListener('click', e=> {
  let ce=e.target as Node;
  while(ce && ce!==document) {
    for(const f of ClickTraceHandlers) {
      if(f.predicate(<HTMLElement>ce,e)) {
        e.preventDefault(); 
        f.handler(<HTMLElement>ce,e);
        return;
      }
    }
    ce=ce.parentElement;
  }
});

